package empiresmp.feature.shop.backend.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class PreCheckFullData(
    @SerialName("id")
    val id: PreCheckId,
    @SerialName("shop_item_id")
    val shopItemId: ShopItemId,
    @SerialName("telegram_user_id")
    val telegramUserId: String? = null,
    @SerialName("minecraft_name")
    val minecraftName: String,
    @SerialName("server_type")
    val serverType: ServerType,
    @SerialName("unique_phrase")
    val uniquePhrase: String
)
